import './assets/css/animate.css';
import './App.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import Home from './components/pages/home';
import { useEffect, useRef, useState } from 'react';
import Projects from './components/pages/projects';
import Navbar from './components/globalComponents/navbar/navbar';

library.add(far, fab, fas)

function Main() {
  const scrollRef = useRef(null);
  const [darkMode, setDarkMode] = useState(
    () => JSON.parse(localStorage.getItem("darkMode")) || false)
  
  useEffect(() => {
      localStorage.setItem("darkMode", darkMode)
      window.scrollTo(0, 0)
    }, [darkMode])

  function toggleDarkMode() {
    setDarkMode(prevState => !darkMode)
  }

  return (
    <div className="App animate__fadeIn animate__animated animate__fadeIn animate__fast" ref={scrollRef}>
      <Navbar toggleDarkMode={toggleDarkMode} darkMode={darkMode}/>
        <div className="parent-container">
          <Home darkMode={darkMode} />
          <Projects darkMode={darkMode}/>
        </div>
    </div>
  );
}

export default Main;
